export * from './lab-result.component';

